import { render } from "./CardDetails.vue?vue&type=template&id=5da68ff0&scoped=true"
import script from "./CardDetails.vue?vue&type=script&lang=js"
export * from "./CardDetails.vue?vue&type=script&lang=js"

import "./CardDetails.vue?vue&type=style&index=0&id=5da68ff0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da68ff0"]])

export default __exports__